module.exports = __webpack_public_path__ + "media/images/service/n_10-caf7ad5112988d01600046afe9462860.jpg";